import React from "react";
import PropTypes from "prop-types";

import { Button } from "arv-reactcomponents";

const SizeBlock = props => {
  let sizeArray = [];
  const { skus, selectedSkuId, selectSku, ProductLoader } = props;
  let sizeBlock = null;
  if (ProductLoader) {
    sizeBlock = (
      <div className="nw-size-block">
        <div className="nw-size-title nwc-contentloader" />
        <div className="nw-size-list nwc-contentloader" />
      </div>
    );
  } else if (skus && skus.length > 0) {
    sizeArray = skus.map(sku => {
      const disabled = !sku.inStock || !sku.sellableQuantity > 0;
      const sizeAttr = {
        disabled,
      };
      const selected = selectedSkuId === sku.skuId ? "selected" : "";
      return (
        <Button
          itemProp="offers"
          itemScope
          itemType="http://schema.org/Offer"
          className={`nw-size-chip  ${selected}`}
          key={sku.skuId}
          onClick={() => selectSku(sku)}
          {...sizeAttr}
        >
          <span itemProp="sku" className="nwc-hide">
            {sku.skuId}
          </span>
          <span itemProp="priceCurrency" content="INR" className="nwc-hide">
            Rs.
          </span>
          <span itemProp="price" className="nwc-hide">
            {sku.price}
          </span>
          <span
            itemProp="availability"
            href="http://schema.org/InStock"
            className="nwc-hide"
          >
            {sku.inStock ? "In Stock" : "Out of Stock"}
          </span>
          {sku.size}
        </Button>
      );
    });
    sizeBlock = (
      <div className="nw-size-block">
        <div className="nw-size-title">SIZE:</div>
        <div className="nw-size-list nwc-custom-scrollbar">{sizeArray}</div>
      </div>
    );
  }
  return sizeBlock;
};

SizeBlock.defaultProps = {
  selectedSkuId: "",
  skus: [],
};

SizeBlock.propTypes = {
  selectSku: PropTypes.func.isRequired,
  skus: PropTypes.arrayOf(PropTypes.shape({})),
  selectedSkuId: PropTypes.string,
  ProductLoader: PropTypes.bool.isRequired,
};

export default SizeBlock;



// WEBPACK FOOTER //
// ./src/component/ProductList/SizeBlock/index.js